import { SyncUserParams, SyncUserResponse } from '@app/models/saga';
import sagaServices from '@app/services/saga';
import { RequestLoading } from '@app/utils/constants';
import { handleErrorResponse } from '@app/utils/helpers';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

const requests = ['syncUser'] as const;

type SagaRequest = RequestLoading<(typeof requests)[number]>;

interface State {
  syncUserResponse: SyncUserResponse | undefined;
  syncUserLoading: boolean;
  sagaRequest: SagaRequest;
}

const initialState: State = {
  syncUserResponse: undefined,
  syncUserLoading: false,
  sagaRequest: {
    loading: false,
  },
};

const TYPE_PREFIX = 'saga/';

const syncUser = createAsyncThunk<SyncUserResponse, SyncUserParams>(
  `${TYPE_PREFIX}syncUser`,
  async (data, { rejectWithValue }) => {
    try {
      const result = await sagaServices.syncUser(data);

      return result;
    } catch (error) {
      return rejectWithValue(handleErrorResponse(error));
    }
  },
);

const slice = createSlice({
  name: 'saga',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // syncUser
    builder.addCase(syncUser.pending, (state, action) => ({
      ...state,
      // syncUserLoading: true,
      sagaRequest: {
        loading: true,
        name: 'syncUser',
        status: action.meta.requestStatus,
      },
    }));
    builder.addCase(syncUser.fulfilled, (state, action) => ({
      ...state,
      syncUserResponse: action.payload,
      // syncUserLoading: false,
      sagaRequest: {
        loading: false,
        name: 'syncUser',
        status: action.meta.requestStatus,
      },
    }));
    builder.addCase(syncUser.rejected, (state, action) => ({
      ...state,
      // syncUserLoading: false,
      sagaRequest: {
        loading: false,
        name: 'syncUser',
        status: action.meta.requestStatus,
        error: action.payload ?? action.error,
      },
    }));
  },
});

export { syncUser };

export default slice.reducer;
